import { navigate } from 'gatsby';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Divider, SidebarLayoutProvider, SidebarMenu } from '@opswat/ui';
import { Switch } from '@opswat/ui/primitives';
import { useFileData } from 'services/api/Results';
import { FileDetailsTabs } from 'services/interface';
import { canAccessReports } from 'services/accessControl';
import { useUser } from 'services/User';
import { truncateMiddle } from 'utils/Utils';

export const ArchiveMenu = () => {
    const { t } = useTranslation();
    const { user } = useUser();
    const [isFiltered, setIsFiltered] = useState(false);

    const { data: fileData } = useFileData();
    const parentDataId = fileData?.parent_data_id;
    const { data: parentData } = useFileData({ dataId: parentDataId ?? null });
    const filesInArchive = Array.isArray(fileData?.extracted_files?.files_in_archive)
        ? fileData?.extracted_files?.files_in_archive
        : [];
    const parentInArchive = Array.isArray(parentData?.extracted_files?.files_in_archive)
        ? parentData?.extracted_files?.files_in_archive
        : [];
    const files = filesInArchive.length > 0 ? filesInArchive : parentDataId ? parentInArchive : filesInArchive;
    const fallbackPath = canAccessReports(user) ? '/reports' : '/';
    const backPath = parentDataId ? `/results/file/${parentDataId}/${FileDetailsTabs.Overview}` : fallbackPath;

    return (
        <SidebarLayoutProvider value={{ isCollapsed: false, toggleMenu: () => {}, isSmallScreen: false }}>
            <div className='tw:flex tw:flex-col tw:p-8 tw:w-260 tw:border-r tw:border-neutrals-200 tw:dark:border-neutrals-1000'>
                <div className='tw:inline-flex tw:items-center tw:justify-between'>
                    <div>
                        <Button variant='secondary' icon='back' text={t('Back')} onClick={() => navigate(backPath)} />
                    </div>
                    <div className='tw:inline-flex tw:items-center tw:justify-between tw:gap-8'>
                        <span className='tw:text-note tw:text-neutrals-600'>{t('Detected Only')}</span>
                        <Switch
                            id='archive-menu'
                            checked={isFiltered}
                            onCheckedChange={setIsFiltered}
                            disabled={files.filter((file) => file.detected_by > 0).length === 0}
                        />
                    </div>
                </div>
                {parentData && (
                    <>
                        <Divider isCompact />
                        <span className='tw:pb-8 tw:text-note-paragraph tw:text-neutrals-600'>{t('Parent file')}</span>
                        <SidebarMenu>
                            <SidebarMenu.Item
                                key={parentData?.data_id}
                                icon='file'
                                label={truncateMiddle(
                                    parentData?.display_name ??
                                        parentData?.file_info?.display_name ??
                                        parentData?.data_id ??
                                        '',
                                )}
                                isActive={parentData?.data_id === fileData?.data_id}
                                onClick={() =>
                                    navigate(`/results/file/${parentData?.data_id}/${FileDetailsTabs.Overview}`)
                                }
                            />
                        </SidebarMenu>
                    </>
                )}
                <Divider isCompact />
                <span className='tw:pb-8 tw:text-note-paragraph tw:text-neutrals-600'>{t('Extracted Contents')}</span>
                <SidebarMenu className='tw:overflow-y-auto tw:overscroll-y-none'>
                    {files
                        .filter((file) => (isFiltered ? file.detected_by > 0 : true))
                        .map((file) => (
                            <SidebarMenu.Item
                                key={file.data_id}
                                icon='file'
                                label={truncateMiddle(file.display_name)}
                                isActive={file.data_id === fileData?.data_id}
                                hasIndicator={file.detected_by > 0}
                                onClick={() => navigate(`/results/file/${file.data_id}/${FileDetailsTabs.Overview}`)}
                            />
                        ))}
                </SidebarMenu>
            </div>
        </SidebarLayoutProvider>
    );
};
